<script setup lang="ts">
import type {PolicyDocument} from "~/composables/api";

defineProps<{
    open: boolean
    document: PolicyDocument
}>()

const emit = defineEmits<{
    (e: 'onClose'): void
}>()
</script>

<template>

    <glx-modal :open="open">
        <section class="container">

            <div class="documentWrapper">
                <img class="iconClose" src="/img/policy/img/block2_文件关闭.png" alt='关闭' @click="emit('onClose')"/>

                <img :src="document.bigImg" alt='政策文件' class="imgMain"/>
            </div>
        </section>
    </glx-modal>
</template>

<style scoped lang="scss">
section.container {
    width: 662px;
    height: 937px;

    position: absolute;
    top: 25px;
    left: 50%;
    transform: translateX(-50%);

    > .documentWrapper {
        width: 100%;
        height: 100%;
        transform: scale(0.9);
        position: relative;
        //overflow-y: auto;
        > .iconClose {
            position: absolute;
            right: -20px;
            top: 0;
            z-index: 10;
            transform: translateX(100%);

            object-fit: none;

            &:hover {
                cursor: pointer;
            }
        }

        .imgMain {
            width: 100%;
            height: 100%;
            object-fit: contain;
            //width: 662px;
            //height: 937px;
            //object-fit: fill;
        }


        > .iconToLarge {
            position: absolute;
            right: -20px;
            bottom: 0;
            z-index: 10;
            transform: translateX(100%);

            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>